import * as React from "react";

interface Props {
  white?: boolean;
}

export const SearchIconWhite = (props: Props) => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.167.667c4.14 0 7.5 3.36 7.5 7.5 0 4.14-3.36 7.5-7.5 7.5-4.14 0-7.5-3.36-7.5-7.5 0-4.14 3.36-7.5 7.5-7.5Zm0 13.333A5.832 5.832 0 0 0 14 8.167a5.832 5.832 0 0 0-5.833-5.834 5.831 5.831 0 0 0-5.834 5.834A5.832 5.832 0 0 0 8.167 14Zm7.07.06 2.358 2.356-1.18 1.179-2.356-2.357 1.179-1.179Z"
      fill={props.white ? "#ffffff" : "#424248"}
    />
  </svg>
);
